import React from "react";
import { getNumberWithUnit } from "@hedgefund/shared";
import ReactModal from "@public/ui-toolkit/src/ReactModal";
import { useState } from "react";
import { useFormik } from 'formik';
import { Button, Input } from "@public/ui-toolkit";
import { alertService } from "../Alert";


const TableAUM = ({ title, allocatorInfo, createAllocatorInfo, updateInfo, loading, aum, editButton = true }) => {
  const [open, setOpen] = useState(false);

  // const initialValues = {
  //   id: allocatorInfo ? allocatorInfo.id : 0,
  //   tenantId: allocatorInfo ? allocatorInfo?.tenantId : 0,
  //   stock: allocatorInfo ? allocatorInfo?.stock : null,
  //   governmentBond: allocatorInfo ? allocatorInfo?.governmentBond : null,
  //   corporateBond: allocatorInfo ? allocatorInfo?.corporateBond : null,
  //   cash: allocatorInfo ? allocatorInfo?.cash : null,
  // }

  // const onSubmit = (values, { setSubmitting }) => {
  //   setTimeout(() => {
  //     if (values.id === 0) {
  //       createAllocatorInfo(values, onSuccess);
  //     } else {
  //       updateInfo(values, onSuccessAlert)
  //     }
  //     // formik.resetForm();
  //     setSubmitting(false);
  //   }, 400);
  // };
  const formik = useFormik({

    initialValues: {
      id : allocatorInfo ? allocatorInfo.id : 0,
      // tenantId : allocatorInfo ? allocatorInfo?.tenantId : 0,
      stock: allocatorInfo ? allocatorInfo?.stock : null,
      governmentBond: allocatorInfo ? allocatorInfo?.governmentBond : null,
      corporateBond: allocatorInfo ? allocatorInfo?.corporateBond : null,
      cash: allocatorInfo ? allocatorInfo?.cash : null,
      nde : allocatorInfo ? allocatorInfo?.nde : null,
      fsi : allocatorInfo ? allocatorInfo?.fsi : null,
      idp : allocatorInfo ? allocatorInfo?.idp : null,
     },
    enableReinitialize: true,
    // setFormData(),
    onSubmit: (values) => {
      if (values.id === 0) {
        createAllocatorInfo(values, onSuccess);
      }else{
        updateInfo(values,onSuccessAlert)
      }
      formik.resetForm();
    },
  });

  const onSuccess = () => {
    closeModal();
    alertService.success("Successfully Created.", { autoClose: true });
  }
  const onSuccessAlert = () => {
    closeModal();
    alertService.success("Updated Successfully.", { autoClose: true });
  }
  const closeModal = () => {
    setOpen(false);
  }
  const onOpenModal = () => {
    setOpen(true);
  }

  return (
    <div className="rounded-large bg-white border p-2">
      <div className="pei-box-title d-flex flex-row justify-content-between mr-2 p-2">
        <h5 data-bs-toggle="tooltip" data-bs-placement="top" >
          {title}
        </h5>
        {editButton ? (
        <i style={{ cursor : "pointer" }} class="fa fa-edit" onClick={onOpenModal}></i>
        ) : ("")}
        {/* {allocatorInfo == null ?
          : <i style={{ cursor : "pointer" }} class="fa fa-edit" onClick={onOpenModal}></i>
        } */}
      </div>
      <div className="table-responsive hf-table-2 ">
        <table className="table text-center">
          <thead>
            <tr>
              <th>Stocks</th>
              <th>Government Bonds</th>
              <th>Corporate Bonds</th>
              <th>Cash</th>
            </tr>
          </thead>
          <tbody>
            <tr>

              <td>{allocatorInfo?.stock ? getNumberWithUnit(allocatorInfo.stock) : "N/A"} </td>
              <td>{allocatorInfo?.governmentBond ? getNumberWithUnit(allocatorInfo.governmentBond) : "N/A"}</td>
              <td>{allocatorInfo?.corporateBond ? getNumberWithUnit(allocatorInfo.corporateBond) : "N/A"}</td>
              <td>{allocatorInfo?.cash ? getNumberWithUnit(allocatorInfo.cash) : "N/A"}</td>
            </tr>
            <tr>
              <td colspan="4">Total Value of AUM = {aum ? getNumberWithUnit(aum) : "N/A"}</td>
            </tr>
          </tbody>
          <ReactModal title={"Allocator Information"} open={open} onClose={closeModal}>
                <form onSubmit={formik.handleSubmit}>
                  <div className="modal-body pt-0">
                    { }
                    <div className="row">
                      <div className="mt-3 col-lg-6">
                        <Input
                          type="number"
                          placeholder="Stock"
                          id="stock"
                          label="Stock"
                          forr="stock"
                          props
                          {...formik.getFieldProps("stock")}
                        />
                        <span className="ml-2">{getNumberWithUnit(formik.values?.stock)}</span>
                        {/* <p>{getNumberWithUnit(formData?.stock)}</p> */}
                      </div>
                      <div className="mt-3 col-lg-6">
                        <Input
                          type="number"
                          placeholder="Government Bond"
                          id="governmentBond"
                          label="Government Bond"
                          forr="governmentBond"
                          props
                          {...formik.getFieldProps("governmentBond")}
                        />
                        <span className="ml-2">{getNumberWithUnit(formik.values?.governmentBond)}</span>
                      </div>
                      <div className="mt-1 col-lg-6">
                        <Input
                          type="number"
                          placeholder="Corporate Bond"
                          id="corporateBond"
                          label="Corporate Bond"
                          forr="corporateBond"
                          props
                          {...formik.getFieldProps("corporateBond")}
                        />
                        <span className="ml-2">{getNumberWithUnit(formik.values?.corporateBond)}</span>
                      </div>
                      <div className="mt-1 col-lg-6">
                        <Input
                          type="number"
                          placeholder="Cash"
                          id="cash"
                          label="Cash"
                          forr="cash"
                          props
                          {...formik.getFieldProps("cash")}
                        />
                        <span className="ml-2">{getNumberWithUnit(formik.values?.cash)}</span>
                      </div>
                    </div>
                  </div>
                  <div className="justify-content-center align-items-center d-flex">
                    <Button
                      btnName="Save"
                      btnType="primary"
                      type="submit"
                      dataDismiss="modal"
                      loading={loading}
                    />
                  </div>
                </form>
          </ReactModal>
        </table>
      </div>
    </div>
  );
};

export default TableAUM;
